import { render, staticRenderFns } from "./ExportToImage.vue?vue&type=template&id=18ecdffa&scoped=true"
import script from "./ExportToImage.vue?vue&type=script&lang=js"
export * from "./ExportToImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ecdffa",
  null
  
)

export default component.exports